import { SvgIconComponent } from '@cp/ds/src/components/svgIcon';
import { PlayIcon } from '@cp/ds/src/icons/play';
import { AttachmentType } from '@common/model/resource/attachment/type';
import { CatalogItemViewModel } from '@common/model/catalog/item/view';
import { AttachmentViewModel } from '@common/model/resource/attachment/viewModel';
import { useClientAudioById } from '../../../clientAudio';
import { ClientAudioResponse } from '@common/model/client/audio/response';

export const useCatalogItemMediaWithClientAudio = (
  data: CatalogItemViewModel,
): { 
  media: AttachmentViewModel | undefined; 
  icon: SvgIconComponent | undefined;
  clientAudio: ClientAudioResponse | undefined;
  hasClientAudio?: boolean
} => {
  const iconComponentVariant = {
    [AttachmentType.Audio]: PlayIcon,
    [AttachmentType.Video]: PlayIcon,
  };

  const catalogMedia = data.media.find(({ type: attachmentType }) => AttachmentType.Audio === Number(attachmentType));
  
  const { firstAudio: clientAudio, hasAudio: hasClientAudio, audioFiles, isLoading, error } = useClientAudioById(data.clientProfile?.id);

  const media = clientAudio ? {
    id: clientAudio.id,
    src: clientAudio.audioUrl,
    type: AttachmentType.Audio,
    durationInMs: undefined,
    updatedAt: clientAudio.updatedAt,
    createdAt: clientAudio.createdAt,
  } as AttachmentViewModel : catalogMedia;

  return {
    media,
    icon: (media || clientAudio) && iconComponentVariant[AttachmentType.Audio],
    clientAudio,
    hasClientAudio,
  };
};
